import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@infra/auth/auth.service';
import { ServicoExecutadoModel } from '@app/data/servico-executado/models';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { ServicoExecutadoController } from '@modules/servicos-executados/controllers';
import { CustomValidators } from '@shared/validators';
import { Campo } from '@components/form/form.component';
import { Coluna } from '@components/table/table.component';
import { Acao } from '@components/filtros/filtros.component';
import { DetalhesServicoExecutadoComponent } from '@modules/servicos-executados/components/detalhes-servico-executado/detalhes-servico-executado.component';
import { dateFormat } from '@app/shared/formatters';

@Component({
  selector: 'app-servicos-executados',
  templateUrl: './servicos-executados.component.html',
  styleUrls: ['./servicos-executados.component.scss'],
})
export class ServicosExecutadosComponent extends BaseListagemComponent<ServicoExecutadoModel> {
  protected filtros: Campo[] = [
    {
      name: 'contrato.grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      icon: 'insert_drive_file',
      width: '20%',
      mask: '0*',
      validators: [],
    },
    {
      name: 'veiculo.placa',
      label: 'Placa',
      type: 'text',
      icon: 'directions_car',
      width: '20%',
      mask: '',
      validators: [],
    },
    {
      name: 'aprovacaoCliente',
      label: 'Aprovação do Cliente',
      type: 'select',
      icon: 'check_circle_outline',
      width: '20%',
      selectOptions: {
        items: [
          { label: 'Aprovada', value: 'A' },
          { label: 'Em análise', value: 'E' },
          { label: 'Reprovada', value: 'R' },
        ],
      },
      validators: [],
    },
    {
      name: 'situacao',
      label: 'Situação',
      type: 'select',
      icon: 'info_outline',
      width: '20%',
      selectOptions: {
        items: [
          { label: 'Aberta', value: 'A' },
          { label: 'Fechada', value: 'F' },
          { label: 'Cancelada', value: 'C' },
        ],
      },
      validators: [],
    },
    {
      name: 'itens.reembolsavel',
      label: 'Tipo',
      type: 'select',
      icon: 'attach_money',
      width: '20%',
      selectOptions: {
        items: [
          { label: 'Reembolsáveis', value: 'S' },
          { label: 'Não reembolsáveis', value: 'N' },
        ],
      },
      validators: [],
    },
    {
      name: 'dataAbertura',
      label: 'Período Abertura',
      type: 'date-range',
      width: '20%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [CustomValidators.data],
    },
  ];

  protected acoes: Acao[] = [];

  protected colunas: Coluna[] = [
    { name: 'numeroGrupoContrato', label: 'Contrato Master' },
    { name: 'numeroOs', label: 'Nº OS' },
    { name: 'dataAbertura', label: 'Data de Abertura', format: dateFormat },
    { name: 'placa', label: 'Placa' },
    { name: 'numeroAtendimento', label: 'Nº Atendimento' },
    { name: 'tipoItem', label: 'Tipo' },
    { name: 'modelo', label: 'Modelo' },
    { name: 'situacao', label: 'Situação' },
    { name: 'numeroFatura', label: 'Nº Fatura' },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Ver detalhes',
          icon: 'visibility',
          action: this.verDetalhes.bind(this),
        },
      ],
    },
  ];

  constructor(public servicoExecutadoController: ServicoExecutadoController, private authService: AuthService, private dialog: MatDialog) {
    super('Serviços Executados - Portal do Cliente', servicoExecutadoController);
  }

  private verDetalhes(servicoExecutado: any) {
    const ref = this.dialog.open(DetalhesServicoExecutadoComponent, {
      width: '900px',
      height: '700px',
      data: { id: servicoExecutado.codigoOrdemServico },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.filtrar();
      }
    });
  }
}
